<template>
  <div class="sidebar-logo-container">
    <router-link key="expand" class="sidebar-logo-link" to="/">
      <div class="sidebar-logo"></div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "SidebarLogo",
  props: {},
  data() {
    return {
      title: "Vue Element Admin",
    };
  },
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  overflow: hidden;
  background: #fff;
  margin-bottom: 10px;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      background-color: #fff;
      background-image: url("@/assets/login_images/logo.png");
      background-position: 50%;
      background-repeat: no-repeat;
      background-size: auto 80%;
      display: block;
      height: 50px;
    }
  }
}
</style>
